import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartJSLineChartComponent } from './chart-js-linechart/chart-js-linechart.component';
import { ChartJSBarchartComponent } from './chart-js-barchart/chart-js-barchart.component';
import { ChartJSScatterchartComponent } from './chart-js-scatterchart/chart-js-scatterchart.component';
import { ChartJsBubbleChartComponent } from './chart-js-bubble-chart/chart-js-bubble-chart.component';
import { ChartDirective } from './chart.directive';

@NgModule({
	declarations: [ChartJSLineChartComponent, ChartJSBarchartComponent, ChartJSScatterchartComponent, ChartJsBubbleChartComponent, ChartDirective],
	imports: [CommonModule],
	exports: [ChartJSLineChartComponent, ChartJSBarchartComponent, ChartJSScatterchartComponent, ChartJsBubbleChartComponent, ChartDirective],
})
export class ChartJSModule {}
